
        if (import.meta.env.VITE_APP_ENV === 'prod') {
            const script = document.createElement('script')
            script.defer = true
            script.id = 'cookieyes'
            script.type = 'text/javascript'
            script.src = 'https://cdn-cookieyes.com/client_data/52c729a3a4536968c693c809/script.js'
            document.body.appendChild(script)
        }
    